import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { InsidePreview } from './components/InsidePreview';
import { MetaPixel } from './components/MetaPixel';
import { Modules } from './components/Modules';
import { Pricing } from './components/Offers';
import { Pain } from './components/Pain';
import { Teachers } from './components/Teachers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-accent selection:text-white" data-id="element-0" data-mp="2whxabqim5ie4">
      <MetaPixel data-id="element-1" data-mp="23vkv2fqfs7kp" />
      <TopBar data-id="element-2" data-mp="23w4e5zrtp20b" />
      <main data-id="element-3" data-mp="23ujkecdc1n3i">
        <Hero data-id="element-4" data-mp="23ut9zyugts8o" />
        <Pain data-id="element-5" data-mp="23t8iki3g6pf1" />
        <HowItWorks data-id="element-6" data-mp="3ijxpcqos80jw" />
        <Teachers data-id="element-7" data-mp="3ikh829m9asyz" />
        <Modules data-id="element-8" data-mp="3iiwf2oflbi38" />
        <InsidePreview data-id="element-9" data-mp="3ijfv1zlojwem" />
        <Bonuses data-id="element-10" data-mp="3ii4t85bsoyq5" />
        <Pricing data-id="element-11" data-mp="3mlawd43m29se" />
        <Guarantee data-id="element-12" data-mp="3mkrd9k285fcs" />
        <Faq data-id="element-13" data-mp="3mk85uxa7a9d0" />
        <FinalCta data-id="element-14" data-mp="3mjzpuwis6nxl" />
      </main>
      <Footer data-id="element-15" data-mp="3rc9f0ac2njyt" />
      <FloatingElements data-id="element-16" data-mp="3rcj31sdk3h1v" />
      <noscript data-id="element-17" data-mp="3rdaselgk8ijp">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-18" data-mp="3rcsw5otwe4bs" />
      </noscript>
    </div>;
}